/** 로그인 팝업 공지 본문 캐시 — updated_at(버전)이 같으면 네트워크 본문 생략 */

import type { SchoolNoticeRow } from '../types/schoolNotice';

const STORAGE_KEY = 'cp.loginNoticeContent.v1';

type LoginNoticeCachePayload = {
  id: string;
  updated_at: string;
  row: SchoolNoticeRow;
};

export function loadLoginNoticeContentCache(): LoginNoticeCachePayload | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<LoginNoticeCachePayload>;
    if (!parsed || typeof parsed !== 'object') return null;
    const id = typeof parsed.id === 'string' ? parsed.id.trim() : '';
    const updated_at = typeof parsed.updated_at === 'string' ? parsed.updated_at.trim() : '';
    const row = parsed.row;
    if (!id || !updated_at || !row || typeof row !== 'object') return null;
    if (String((row as SchoolNoticeRow).id ?? '') !== id) return null;
    return { id, updated_at, row: row as SchoolNoticeRow };
  } catch {
    return null;
  }
}

export function saveLoginNoticeContentCache(row: SchoolNoticeRow): void {
  if (typeof window === 'undefined') return;
  const id = String(row.id ?? '').trim();
  const updated_at = String(row.updated_at ?? '').trim();
  if (!id || !updated_at) return;
  try {
    const payload: LoginNoticeCachePayload = { id, updated_at, row };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota */
  }
}

export function clearLoginNoticeContentCache(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
